module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"create_review":"撰寫商品評論"}}')
  delete Component.options._Ctor
}
